<div class="modal-header">
  <h4 class="modal-title">
    Bestellposition
  </h4>
  <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
  </button>
</div>

<div class="modal-body">
  <form [formGroup]="itemForm" (ngSubmit)="addItem()">
    <div class='col'>

      <div class='row form-group'>

        <div class='col'>
          <label for="IdProduct">Wählen Sie das Produkt aus*</label>
          <select class="form-control" (change)="setVariants($event)" formControlName="IdProduct" required="true"
            [class.nb-form-error]="!itemForm.controls.IdProduct.valid">
            <option *ngFor="let product of products" [value]="product.Id">
              {{product.Name}}({{product.IdDisplay}})
            </option>
          </select>
          <small class="text-danger" *ngIf="!itemForm.controls.IdProduct.valid">
            <p>Muss ausgewählt sein.</p>
          </small>
        </div>

        <div class='col'>
          <label for="Quantity">Anzahl*</label>
          <input class="form-control" [class.nb-form-error]="!itemForm.controls.Quantity.valid" formControlName="Quantity"
            required="true" pattern="[0-9]+">
          <small class="text-danger" *ngIf="!itemForm.controls.Quantity.valid">
            <p>
              Das Feld muss ausgefüllt sein und darf nur aus Nummern bestehen.
            </p>
          </small>
        </div>

      </div>

    </div>
  </form>

</div>

<div class="modal-footer">
  <button class='btn btn-default' (click)="activeModal.dismiss()">
    Schließen
  </button>
  <button class='btn btn-success' [disabled]="!itemForm.valid" (click)="addItem()">
    Hinzufügen
  </button>
</div>